import React, { useState } from "react";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridNoRecords,
  GridRowProps,
} from "@progress/kendo-react-grid";
import { SortDescriptor } from "@progress/kendo-data-query";
import { Icon } from "@iconify/react";


function CandidateLeavesDetails(Props: any) {

  const initialSort: Array<SortDescriptor> = [{ field: "", dir: "asc" }]

  const [sort, setSort] = useState(initialSort)


  return (
    <div className="contentBox">
      <div className="innerPadd48">
      <Grid
          data={Props.state.items}
          onPageChange={Props.pageChange}
          total={Props.state.total}
          skip={Props.state.skip}
          pageable={Props.state.pageable}
          pageSize={Props.state.pageSize}
        >
          <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
        <Column field="month" title="Month"  width="300px"/>
        <Column field="leaves" title="Number of Leaves" width="500px"/>
        <Column field="compOff" title="Number of Compensatory off" width="500px"/>
      </Grid>
      </div>
    </div>
  );
}

export default CandidateLeavesDetails;




